import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import qs from 'qs'
import merge from 'lodash/merge'
import { clearLoginInfo } from '@/utils'

const http = axios.create({
  timeout: 1000 * 30,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  // config.headers['LPSWUTGT'] = Vue.cookie.get('LPSWUTGT') // 请求头带上LPSWUTGT
  // config.headers['LPSState'] = Vue.cookie.get('LPSState') // 请求头带上LPSState
  // config.headers['LoginSource'] = Vue.cookie.get('LoginSource') // 请求头带上LoginSource
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        var loginSource = sessionStorage.getItem("loginSource") ? sessionStorage.getItem("loginSource") :"home-page"
        location.href = location.protocol + '//' + location.host + '/' + loginSource 
    }
  }
  return Promise.reject(error.response)   // 返回接口返回的错误信息
})

/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornUrl = (actionName) => {
  // 非生产环境, 接口前缀统一使用[/apis/]前缀做代理拦截!
  return (process.env.NODE_ENV !== 'production'  ? '/apis/' : `${location.origin}/`) + actionName
}

/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
http.adornParams = (params = {}, openDefultParams = true) => {
  var defaults = {
    't': new Date().getTime()
  };
  return  merge(defaults, params)
}

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
http.adornData = (data = {}, openDefultdata = true, contentType = 'json') => {
  // var defaults = {
  //   't': new Date().getTime()
  // }
  // data = openDefultdata ? merge(defaults, data) : data
  return contentType === 'json' ? JSON.stringify(data) : qs.stringify(data)
}

http.getST = (v, realm) => {
  return http({
    method: 'get',
    url: http.adornUrl('accountinfo/personal/lpsust/' + v + '/' + realm),
    params: http.adornParams()
  })
};

http.accountinfoGeo = () => {
    return http({
        method: 'get',
        url: http.adornUrl('accountinfo/geo'),
        params: http.adornParams()
    })
};

http.getCookie = () => {
  return http({
    method: 'get',
    url: http.adornUrl(`accountinfo/cookie`),
    params: http.adornParams()
  })
};

http.setCookie = (lang) => {
  return http({
    method: 'post',
    url: http.adornUrl(`accountinfo/cookie/${lang}`),
    params: http.adornParams()
  })
};

export default http



// WEBPACK FOOTER //
// ./src/utils/httpRequest.js